const DigicomList = () => import("@/views/digicom/list.vue");

export default [
    { path: "/digicom/list/:orderId?", name: "digicom_list", component: DigicomList, props: true, meta: {title: 'Centraal Boekhuis messages'} },
]
